import React, { useState } from 'react';
import { Image } from 'antd';
import { env } from '../../../env/env';
import { LoadingOutlined } from "@ant-design/icons";

export function ItemThumbsPreview({ item }: any) {
  const [visible, setVisible] = useState(false);

  return (
    <div className="thumb">
      <Image
        alt={item.designName}
        loading="eager"
        src={`${env.rendererPath}/design/thumbnail/${item.designId}?height=${env.rendererImageHeight}`}
        preview={{ visible: false }}
        placeholder={<LoadingOutlined style={{ fontSize: 40, color: '#bbb', marginTop: 40, marginLeft: 40 }} />}
        onClick={() => setVisible(true)}
      />

      <div style={{ display: 'none' }}>
        <Image.PreviewGroup preview={{ visible, onVisibleChange: vis => setVisible(vis) }}>
          {Array.from({ length: item.pages }, (_, page) => (
            <Image
              key={page}
              alt={`${item.designName} - Page ${page + 1}`}
              src={`${env.rendererPath}/design/thumbnail/${item.designId}?height=1200&page=${page + 1}`}
              placeholder={<LoadingOutlined style={{ fontSize: 40, color: '#bbb', marginTop: 40, marginLeft: 40 }} />}
            />
          ))}
        </Image.PreviewGroup>
      </div>
    </div>
  );
};
